import { render, staticRenderFns } from "./franchise.vue?vue&type=template&id=8cc5fc06&scoped=true&"
import script from "./franchise.vue?vue&type=script&lang=js&"
export * from "./franchise.vue?vue&type=script&lang=js&"
import style0 from "./franchise.vue?vue&type=style&index=0&id=8cc5fc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc5fc06",
  null
  
)

export default component.exports